/* Edge-Glow für Buttons und Pillen (Vanilla-Port von Mikes CursorEdgeGlowButton):
   Lichtfleck folgt der Maus mit Feder-Physik, Rand glüht auf der Seite, zu der die Maus zieht. Farbe aus --glow. */
(() => {
  const FREQUENCY = 3.4, DAMPING = 0.78, GLOW_RISE = 0.5, EDGE_SATURATION = 0.55, EDGE_BRIGHTNESS = 0.12, HUE_SHIFT = -5;
  const ring = '<span class="g1"></span><span class="g2"></span><span class="g3"><span class="g4"></span></span>';
  const markup = `<span class="dw-glow dw-glow--r" aria-hidden="true">${ring}</span><span class="dw-glow dw-glow--l" aria-hidden="true">${ring}</span>` +
    '<span class="dw-light" aria-hidden="true"><span class="dw-light__track"><span class="b1"></span><span class="b2"></span></span></span>';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Startseite: Buttons, Bestseller-Pillen, „Zum Ansehen ziehen“; Produktseite: Warenkorb-Button (auch in der Sticky-Leiste) und „An deiner Wand ansehen“
  const SELECTOR = '.dw-story :is(.dw-btn, .dw-ribbon, .dw-hint), .shopify-section--main-product buy-buttons .button, .ar-wall-viewer__btn';

  function setup(el) {
    if (el.dataset.glow) return;
    el.dataset.glow = '1';
    el.classList.add('dw-glowable');
    el.insertAdjacentHTML('afterbegin', markup);
    const track = el.querySelector('.dw-light__track'), right = el.querySelector('.dw-glow--r'), left = el.querySelector('.dw-glow--l');
    let bound = el.offsetWidth / 2 + 12, x = bound, v = 0, target = bound, inside = false, last = 0, raf = null;

    const paint = () => {
      track.style.setProperty('--light-x', x.toFixed(2) + 'px');
      const n = Math.max(-1, Math.min(1, x / bound)), m = Math.abs(n), k = Math.pow(m, GLOW_RISE);
      const tune = `hue-rotate(${HUE_SHIFT}deg) saturate(${(1 + EDGE_SATURATION * m).toFixed(3)}) brightness(${(1 + EDGE_BRIGHTNESS * m).toFixed(3)})`;
      right.style.opacity = (n > 0 ? k : 0).toFixed(3);
      left.style.opacity = (n < 0 ? k : 0).toFixed(3);
      right.style.filter = left.style.filter = tune;
    };
    new ResizeObserver(() => { bound = el.offsetWidth / 2 + 12; }).observe(el);
    paint();
    if (reduce) return;

    const frame = (now = performance.now()) => {
      const dt = Math.min((now - last) / 1000, 0.032), w = 2 * Math.PI * FREQUENCY;
      last = now;
      v += (w * w * (target - x) - 2 * DAMPING * w * v) * dt;
      x += v * dt;
      paint();
      if (inside || Math.abs(target - x) > 0.15 || Math.abs(v) > 0.6) raf = requestAnimationFrame(frame);
      else { raf = null; x = target; v = 0; paint(); }
    };
    const kick = () => { if (raf === null) { last = performance.now(); raf = requestAnimationFrame(frame); } };

    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      inside = true;
      target = Math.max(-bound, Math.min(bound, e.clientX - (r.left + r.width / 2)));
      kick();
    });
    el.addEventListener('pointerleave', () => { inside = false; target = x; kick(); });
    el.addEventListener('focus', () => { inside = false; target = 0; kick(); });
    el.addEventListener('blur', () => { inside = false; target = x; kick(); });
  }

  const init = (root = document) => root.querySelectorAll(SELECTOR).forEach(setup);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
